import fetchDirectory from '../Services/fetchDirectory';
import { setSelectedItemPath } from '../State/selectedItemPath';

export default () => async (dispatch) => {
  
  dispatch(fetchDirectory());
  dispatch(setSelectedItemPath(''));
  
}